import type { ReactNode } from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { Eyebrow } from "@/components/brand/Eyebrow";

interface PageShellProps {
  eyebrow: string;
  title: string;
  intro?: string;
  children?: ReactNode;
}

/**
 * Shared shell for stub public routes. Renders navbar, a navy hero strip
 * with the page title, and the global footer. Replace `children` as
 * each section is built out in subsequent prompts.
 */
export function PageShell({ eyebrow, title, intro, children }: PageShellProps) {
  return (
    <div className="flex min-h-screen flex-col bg-cream-50">
      <Navbar />
      <main className="flex-1 pt-20">
        <section className="bg-navy-900 text-cream-50">
          <div className="mx-auto max-w-7xl px-5 py-24 md:px-10 md:py-32">
            <Eyebrow color="cream">{eyebrow}</Eyebrow>
            <h1 className="mt-6 max-w-3xl font-display text-cream-50">{title}</h1>
            {intro && (
              <p className="mt-6 max-w-2xl font-sans text-lg leading-relaxed text-cream-50/80">
                {intro}
              </p>
            )}
          </div>
        </section>
        {children ?? (
          <section className="mx-auto max-w-7xl px-5 py-20 md:px-10 md:py-28">
            <p className="font-sans text-base text-charcoal-500">
              Content coming soon.
            </p>
          </section>
        )}
      </main>
      <Footer />
    </div>
  );
}

export default PageShell;